var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

let {
  property,
  is_mobile,
  homes_around_title,
  haven_cta_enabled,
  ldp_collapse_disabled,
  address_unavailable,
  haven_myhome_tracking_enabled,
  is_user_claimed_home,
  haven_property_cta,
  map
} = options;

__p+='\n\n';
 if (property.homes_near_street.properties.length >= 4) { 
__p+='\n  ';
 if (MOVE_DATA.full_ldp_modules === 'V1' || MOVE_DATA.full_ldp_modules === 'V2') { 
__p+='\n    <div class="accordion js-homes-around-collapse">\n      <div class="panel" role="tablist">\n        <div id="ldp-accordion-homes-around" class="accordion-heading full-ldp-collasped-accordion collapsed" role="tab" data-toggle="collapse" href="#ldp-collapsed-homes-around" aria-expanded="false" aria-controls="ldp-collapsed-homes-around" data-module-type="homes-around">\n          <h2 class="title-section accordion-title full-ldp-collasped-title-section">\n            <i class="ra ra-homes-around icon-space-right"></i>'+
((__t=( homes_around_title ))==null?'':__t)+
'\n          </h2>\n        </div>\n        <div id="ldp-collapsed-homes-around" class="panel-collapse collapse" role="tabpanel" aria-labelledby="ldpCollapseHomesAround">\n          <div class="panel-body">\n            <div id="homes-near-street">\n              <div class="listing-section-nearyby-recentlysold ';
 if (!is_mobile) { 
__p+='section-title-on-map';
 } 
__p+='" id="ldp-recently-sold-around-map">\n                <div class="ldp-recently-sold-map-wrapper" id="ldp-recently-sold-map-wrapper">\n                  <div class="ldp-recently-sold-map">\n                    <div class="map-main-container ldp-recently-sold-map-container" id="recentlySoldAroundMap"\n                      ';
 if (property.lat && property.long) { 
__p+=' data-property-lat="'+
((__t=( property.lat ))==null?'':__t)+
'" data-property-long="'+
((__t=( property.long ))==null?'':__t)+
'"';
 } 
__p+='>\n                    </div>\n                  </div>\n                  <div class="ldp-recently-sold-card" id="ldp-recently-sold-card">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
 } else { 
__p+='\n    <div id="homes-near-street">\n      <div class="listing-section-nearyby-recentlysold ';
 if (!is_mobile) { 
__p+='section-title-on-map';
 } 
__p+='" id="ldp-recently-sold-around-map">\n        ';
 if (ldp_collapse_disabled) {  
__p+='\n          <h2 class="ldp-title-section">\n            <i class="ra ra-homes-around"></i>'+
((__t=( homes_around_title ))==null?'':__t)+
'\n          </h2>\n        ';
 } 
__p+='\n        <div class="ldp-recently-sold-map-wrapper" id="ldp-recently-sold-map-wrapper">\n          <div class="ldp-recently-sold-map">\n            <div class="map-main-container ldp-recently-sold-map-container" id="recentlySoldAroundMap"\n              ';
 if (property.lat && property.long) { 
__p+=' data-property-lat="'+
((__t=( property.lat ))==null?'':__t)+
'" data-property-long="'+
((__t=( property.long ))==null?'':__t)+
'"';
 } 
__p+='>\n            </div>\n          </div>\n          <div class="ldp-recently-sold-card" id="ldp-recently-sold-card">\n          </div>\n        </div>\n      </div>\n    </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/homes_near_street.jst.ejs